module.exports = __webpack_public_path__ + "img/bullet.e0ded14b.svg";